import { AbstractModel, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { BannerSeverity } from './banner-severity';
import { BannerType } from './banner-type';

@inheritSerialization(AbstractModel)
export class Banner extends AbstractModel {
  @autoserialize
  message: string;

  @autoserialize
  payload: string;

  @autoserialize
  persistent: boolean;

  @autoserializeAs(Date)
  startDate: Date;

  @autoserializeAs(Date)
  endDate: Date;

  @autoserialize
  active: boolean;

  @autoserializeAs(BannerType)
  bannerType: BannerType;

  @autoserializeAs(BannerSeverity)
  bannerSeverity: BannerSeverity;

  @autoserialize
  transitProgramIds: Array<number>;

  @autoserialize
  appIds: Array<number>;

  // Action properties are local only
  actionLinkText: string;

  action: (banner: Banner) => void;

  /**** Serialization ****/

  static OnSerialized(instance: Banner, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.startDate)) {
      json.startDate = DateUtil.serializeDate(instance.startDate);
    }
    if (!isNullOrUndefined(instance.endDate)) {
      json.endDate = DateUtil.serializeDate(instance.endDate);
    }
  }

  static OnDeserialized(instance: Banner, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['startDate'])) {
      instance.startDate = DateUtil.deserializeDate(json['startDate']);
    }

    if (!isNullOrUndefined(json['endDate'])) {
      instance.endDate = DateUtil.deserializeDate(json['endDate']);
    }
  }

  /**** Comparison ****/

  equals(banner: Banner): boolean {
    if (!isNullOrUndefined(this.id) && this.id === banner.id) {
      return true;
    }

    return this.message === banner.message && this.actionLinkText === banner.actionLinkText;
  }
}
